import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

function cleanup(instance) {
  instance.element.removeEventListener('keydown', instance.keyDownHandler);
}

class OnEscapeModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    registerDestructor(this, cleanup);
  }

  onEscape = null;
  element = null;

  modify(_element, [onEscape, attachToElement = false]) {
    this.onEscape = onEscape;
    this.element = attachToElement ? _element : document;
    this.element.addEventListener('keydown', this.keyDownHandler);
  }

  clearFocus() {
    document.activeElement.blur();
  }

  keyDownHandler = (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      /**
       * To prevent side effects of esc key event on forms,
       * otherwise we run into a situation where pressing escape while focused on an input with invalid entry
       * would cause changeset to change its errors property and also call modal close at the same time leading to render warnings from Ember
       */
      this.clearFocus();

      this.onEscape();
    }
  };
}

export default OnEscapeModifier;
